<template>
    <div id="Home" v-if="!isLoading">
        <Header ref="header" :currentPage="currentPage" v-if="!showSetupCompletion" />
        <Content
            ref="content"
            @page-changed="handlePageChange"
            @form-validity="handleFormValidity"
            :apiData="apiData"
            v-if="!showSetupCompletion"
        />
        <Footer
            @next-page="handleNextPage"
            @previous-page="handlePreviousPage"
            :currentPage="currentPage"
            :isNextButtonDisabled="isNextButtonDisabled"
            :siteId="siteId"
            v-if="!showSetupCompletion"
        />
        <SetupCompletion v-if="showSetupCompletion" />
    </div>
</template>

<script>
import Header from "./views/Header.vue";
import Content from "./views/Content.vue";
import Footer from "./views/Footer.vue";
import SetupCompletion from "./views/page/SetupCompletion.vue";
import { getCurrentStep, loadFromLocalStorage, saveToLocalStorage } from "../utils/formStore.js";

export default {
    name: "HomePage",
    components: {
        Header,
        Content,
        Footer,
        SetupCompletion,
    },
    data() {
        return {
            currentPage: getCurrentStep(),
            isNextButtonDisabled: true,
            startTime: Date.now(),
            isLoading: true,
            apiData: {},
            formState: loadFromLocalStorage(),
            siteId: "",
            elapsedTime: 0,
            timer: null,
            showSetupCompletion: false,
            timeoutReached: false,
            userCompleted: false
        }
    },
    watch: {
        currentPage() {
            this.$nextTick(() => {
                this.updateCompletedPages();
            });
        },
        formState: {
            handler(newVal) {
                saveToLocalStorage(newVal);
            },
            deep: true,
        }
    },
    methods: {
        handleNextPage() {
            this.$refs.content.nextPage();
        },
        handlePreviousPage() {
            this.$refs.content.previousPage();
        },
        handlePageChange(page) {
            this.currentPage = page;
        },
        handleFormValidity(isValid) {
            this.isNextButtonDisabled = !isValid;
        },
        startTimer() {
            this.timer = setInterval(() => {
                this.elapsedTime++;
                if(this.elapsedTime > 45) {
                    this.handleTimeout();
                }
            }, 1000);
        },
        handleTimeout() {
            this.timeoutReached = true;
            if(!this.userCompleted) {
                this.redirectToSupsisPanel();
            }
        },
        redirectToSupsisPanel() {
            const siteName = new URLSearchParams(window.location.search).get('sitename');
            window.location.href = `https://${siteName || 'code1.local.supsis.live'}`;
        },
        startTimeout() {
            this.timeoutId = setTimeout(() => {
                this.redirectToSupsisPanel();
            }, 45000);
        },
        async fetchData() {
            this.isLoading = true;
            const spinner = document.createElement("div");
            spinner.className = "loading-spinner";
            document.body.appendChild(spinner);

            const minLoadingTime = new Promise(resolve => setTimeout(resolve, 1000));
            const urlParams = new URLSearchParams(window.location.search);

            const sitename = urlParams.get("sitename");
            try {
                // bu kısım master apisi ile değiştirilicek
                // local api
                // const response = await fetch(`https://tablet-api-local.supsis.live/api/sites/search/${sitename}`);
                // beta api
                // const response = await fetch(`https://beta-api.supsis.live/api/sites/search/${sitename}`);
                // master api
                const response = await fetch(`https://api.supsis.live/api/sites/search/${sitename}`);
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const data = await response.json();
                this.apiData = data;
                this.siteId = data._id;
                await minLoadingTime;
                this.isLoading = false;
                document.body.removeChild(spinner);

                // Check if isLobbyDataFilled is true
                if (data.isLobbyDataFilled) {
                    window.location.href = `https://${data.clientAddress}`;
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        },
        handleCompleteClick() {
            const finalData = loadFromLocalStorage();
            console.log("Final Form Data:", JSON.stringify(finalData, null, 2));
            localStorage.removeItem("formData");
            localStorage.removeItem("currentStep");
        },
        updateCompletedPages() {
            if (this.$refs.header && this.$refs.header.updateCompletedPages) {
                this.$refs.header.updateCompletedPages();
            }
        },
        calculateElapsedTime() {
            return Math.floor((Date.now() - this.startTime) / 1000);
        },
        showSetupScreen() {
            this.showSetupCompletion = true;
        }
    },
    mounted() {
        this.fetchData();
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    computed: {
        elapsedSeconds() {
            return Math.floor((Date.now() - this.startTime) / 1000);
        },
        siteName() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('sitename') || 'code1.local.supsis.live';
        }
    }
};
</script>

<style lang="scss">
#Home {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
}

#Header {
    flex-shrink: 0;
}

#Content {
    flex-grow: 1;
    overflow: auto;
}

#Footer {
    flex-shrink: 0;
}

.loading-spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 16px solid #f3f3f3;
    border-top: 16px solid #272657;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>